import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import createClass from 'create-react-class'
import { desktopBreakpoint } from '../../constants'

/**
 * Scale to select NPS value.
 * @param {ReactClass}
 */
const Input = createClass({
  propTypes: {
    onSubmit: PropTypes.func.isRequired
  },

  getDefaultProps () {
    return {
      onSubmit: value => {}
    }
  },

  getInitialState () {
    return {
      value: null,
      selectedValue: null
    }
  },

  componentDidMount () {
    this.setState({
      selectedValue: this.props.selectedValue
    })
  },

  onMouseEnter (value) {
    this.setState({
      value
    })
  },

  onMouseLeave (value) {
    if (!this.state.selectedValue && this.state.selectedValue !== 0) {
      this.setState({
        value: null
      })
    }
  },

  onSelect (value) {
    const { onSubmit } = this.props

    this.setState({
      selectedValue: value,
      value
    })
    onSubmit(value)
  },

  render () {
    let { value, selectedValue } = this.state

    if (!this.state.isHovering) {
      value = selectedValue || value
    }

    const MIN = 0
    const MAX = this.props.service ? 10 : 6

    return (
      <div className="NPSScale">
        <div
          className="NPSScale-Values"
          onMouseEnter={() => this.setState({ isHovering: true })}
          onMouseLeave={() => this.setState({ isHovering: false })}
        >
          {range(MIN, MAX).map(i => (
            <div
              key={i}
              className={classNames('NPSScale-Value', {
                selected: value !== null && value >= i
              })}
              onMouseEnter={() => this.onMouseEnter(i)}
              onMouseLeave={() => this.onMouseLeave(i)}
              onClick={() => this.onSelect(i)}
            >
              <div>{i}</div>
            </div>
          ))}
        </div>
        <div className="NPSScale-Legend mobile-padding">
          <div className="NPSScale-Label left">
            {window.innerWidth < desktopBreakpoint && (
              <div className="NPSScale-Sublabel">
                {MIN}
                <br />
              </div>
            )}
            {this.props.service ? 'Not at all likely' : 'As good as it can be'}
          </div>
          <div className="NPSScale-Label right">
            {window.innerWidth < desktopBreakpoint && (
              <div className="NPSScale-Sublabel">
                {MAX}
                <br />
              </div>
            )}
            {this.props.service ? 'Extremely likely' : 'As bad as it can be'}
          </div>
        </div>
      </div>
    )
  }
})

function range (start, end) {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx)
}

export default Input
